import config from "@config"

import React from "react"
import CardButton from "../button"
import ResponsiveImage from "../responsiveContent/image"
import * as styles from "./eventDate.module.scss"

const Title = ({ children }) => {
  return (
    <div className={styles.title}>
      <span>{children}</span>
    </div>
  )
}

const EventDate = ({
  day1,
  day2,
  date1,
  date2,
  loc1,
  loc2,
  price1Img,
  price2Img,
  link,
}) => {
  return (
    <div className={styles.eventDateContainer}>
      <div className={styles.eventDate}>
        <div>
          <Title>时间</Title>
          <div>
            <div className={styles.date}>
              <div>
                {day1}
                <small>(六)</small>
              </div>
              <div>{date1}</div>
            </div>
            <div className={styles.date}>
              <div>
                {day2}
                <small>(日)</small>
              </div>
              <div>{date2}</div>
            </div>
          </div>
        </div>
        <div>
          <Title>地址</Title>
          <div className={styles.addr}>
            <p>{loc1}</p>
            <p>{loc2}</p>
          </div>
        </div>
        <div>
          <Title>票价</Title>
          <CardButton appNavTo={link}>
            <ResponsiveImage className={styles.price} pc={price1Img} />
          </CardButton>
        </div>
        <div>
          <span />
          <CardButton appNavTo={link}>
            <ResponsiveImage className={styles.price} pc={price2Img} />
          </CardButton>
        </div>
      </div>
    </div>
  )
}

export default EventDate
